import { Object3D, Vector2 } from 'three';
import { BUTTON_PRIMARY_COLOR, BUTTON_PRIMARY_TEXT_COLOR, PROGRESS_BAR_EMPTY, PROGRESS_BAR_LOADED } from '../styleConfig';
import { FuturisticWindow } from './FuturisticWindow';
import { Progressbar, ResourcesManager, VideoViewerComponent, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
export class TutorialVideoComponent extends VideoViewerComponent {
    constructor() {
        super({
            size: new Vector2(10, 6),
            type: '2d',
            radius: 0.15,
            video: document.createElement('video'),
            controls: false
        });
        this.addObject(this.controlsWrapper = new Object3D());
        this.addObject(this.pauseButton = new IconButtonComponent({
            text: 'p',
            diameter: .7,
            textColor: BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
            background: BUTTON_PRIMARY_COLOR.getStyle(),
            iconSize: 0.9
        }));
        this.addObject(this.muteButton = new IconButtonComponent({
            text: 'm',
            diameter: .7,
            textColor: BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
            background: BUTTON_PRIMARY_COLOR.getStyle(),
            iconSize: 0.9
        }));
        this.addObject(this.skipButton = new IconButtonComponent({
            diameter: .7,
            text: 's',
            textColor: BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
            background: BUTTON_PRIMARY_COLOR.getStyle(),
            iconSize: 0.9
        }));
        this.progressbar = new Progressbar({
            size: new Vector2(6.3, 0.3),
            background: PROGRESS_BAR_EMPTY.getHex(),
            backgroundLoaded: PROGRESS_BAR_LOADED.getHex(),
            bordRadius: 0.15,
            bordWidth: 0,
            margin: 0,
        });
        this.progressbar.progress = 0.5;
        this.progressbar.uiObject.position.z = 0.01;
        this.addObject(this.progressbar);
        this.addObject(this.progressbarBackground = new FuturisticWindow({
            size: new Vector2(7, 0.7),
            type: 1,
            hasSideImage: false,
            radius: 0.35,
            borderWidth: 0.02
        }));
        this.addObject(this.videoBackground = new FuturisticWindow({
            size: new Vector2(10 + 0.4, 6 + 0.4),
            type: 2,
            hasSideImage: false,
            radius: 0.15
        }));
        this.videoBackground.uiObject.position.z -= 0.01;
        this.pauseButton.uiObject.parent.remove(this.pauseButton.uiObject);
        this.controlsWrapper.add(this.pauseButton.uiObject);
        this.muteButton.uiObject.parent.remove(this.muteButton.uiObject);
        this.controlsWrapper.add(this.muteButton.uiObject);
        this.skipButton.uiObject.parent.remove(this.skipButton.uiObject);
        this.controlsWrapper.add(this.skipButton.uiObject);
        this.progressbarBackground.uiObject.parent.remove(this.progressbarBackground.uiObject);
        this.controlsWrapper.add(this.progressbarBackground.uiObject);
        this.progressbar.uiObject.parent.remove(this.progressbar.uiObject);
        this.progressbarBackground.uiObject.add(this.progressbar.uiObject);
        Viewer.on('update', () => this.update());
    }
    init() {
        super.init();
        this.video.crossOrigin = 'anonymous';
        this.pauseButton.setText('');
        this.muteButton.setText('');
        this.skipButton.setText('');
        this.progressbarBackground.init();
        this.videoBackground.init();
        ViewerModule.adjustObjects([this.pauseButton.uiObject, this.progressbarBackground.uiObject, this.muteButton.uiObject, this.skipButton.uiObject], true, 0.2);
        this.controlsWrapper.position.set(0, -4, 0);
        this.muteButton.on('click', () => {
            this.video.muted = !this.video.muted;
            if (this.video.muted) {
                this.muteButton.setText(''); // volume
            }
            else {
                this.muteButton.setText(''); // muted
            }
        });
        this.pauseButton.on('click', () => {
            if (!!(this.video.currentTime > 0 && !this.video.paused && !this.video.ended && this.video.readyState > 2)) {
                this.pauseTutor();
            }
            else {
                this.video.play();
                this.pauseButton.setText('');
            }
        });
        this.skipButton.on('click', () => {
            this.video.currentTime = this.video.duration;
            this.fire('ended');
        });
    }
    update() {
        super.update();
        if (this.video && this.progressbar)
            this.progressbar.progress = this.video.currentTime / this.video.duration || 0.0001;
    }
    setTutorialVideo(video) {
        this.uiObject.visible = true;
        super.setVideo(video ? video : undefined);
        this.video.play();
        ResourcesManager.getAudioManger().getAudio('main_theme').pause();
        this.once('ended', () => {
            ResourcesManager.getAudioManger().getAudio('main_theme').play();
        });
    }
    pauseTutor() {
        this.video.pause();
        this.pauseButton.setText('');
    }
}
